import React, { useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { makeStyles } from '@material-ui/styles'
import { Divider, Typography } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  divider: {
    margin: theme.spacing(2, 0),
  },
  name: {
    marginTop: theme.spacing(1),
  },
}))

export const Logo = () => {
  const classes = useStyles()

  return (
    <>
      <RouterLink to="/">
      <div>
         <img
          src={"/images/logos/logo-sigep.png"}
          alt="Logo do SIGEP"
          width={"30%"}
        />
    </div>  
      </RouterLink>
      <Divider className={classes.divider} />
    </>
  )
}
